var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-json-editor',{attrs:{"expandedOnStart":true},on:{"json-change":_vm.onJsonChange},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }